// extracted by mini-css-extract-plugin
module.exports = {"row":"delivery-type-form_row__PUqX5","notification":"delivery-type-form_notification__zg_vh"};